var detecthttp = window.location.protocol;

// === Formula API ortami: 'prod' veya 'dev' ===
var FORMULA_ENV = "prod";
// =============================================
var FORMULA_API_URL =
    FORMULA_ENV === "prod"
        ? "https://api.babybrezzacloud.com/formulas/finder"
        : "https://dev-api.babybrezzacloud.com/formulas/finder";
var FORMULA_IMAGE_BASE =
    FORMULA_ENV === "prod"
        ? "https://babybrezzacloud.com/uploads/formulaprotool/original"
        : "https://dev.babybrezzacloud.com/uploads/formulaprotool/original";
// Eski PHP ucu artik yalnizca analitik loglama icin cagriliyor; yaniti okunmuyor.
var FORMULA_LEGACY_LOG_URL =
    "https://babybrezzaserver.com/index.php/without_response/getsetting";
var FORMULA_API_TIMEOUT = 15000;

var StoreURL = FORMULA_API_URL;
var isEU = false;
var isProAdvanced = false;
var selected_model_type = "";
var selected_country_code = "";
var selected_formula_brand = "";
var salesforce_url = "https://knowledge.babybrezza.com/s/formula-settings?";
var hasCamera = false;

// languageCode is declared on the page.formula-new te3mplate
// console.log("languageCode: ", languageCode);

var detected_upcs = [];

Quagga.onDetected(function (result) {
    if (detected_upcs.includes(result.codeResult.code)) {
        detected_upcs = [];
        // Handle the detected barcode here
        $("#upc_input").val(result.codeResult.code);
        $("#upc_enter").get(0).click();
        Quagga.stop();
        $("#interactive").hide();
    } else {
        detected_upcs.push(result.codeResult.code);
    }
});

const scrollToID = (id) => {
    $("html, body").animate(
        {
            scrollTop: $(id).offset().top - 85,
        },
        250,
        "swing"
    );
};

/* Hatali e-postada: input'a odaklan ve oraya yumusak kaydir.
   focus() tarayicida kendi basina da kaydirir; preventScroll ile onu bastirip
   scrollToID'nin animasyonunun ustune binmesini engelliyoruz. */
function focusEmailInput() {
    var el = document.getElementById("enter_email_input");
    if (!el) return;

    try {
        el.focus({ preventScroll: true });
    } catch (e) {
        el.focus();
    }

    scrollToID("#enter_email_input");
}

// OPTIN KLAVIYO //
async function addInformationToKlaviyo(model_type = "",request_type = "") {
    let optIn;
    let email = document.getElementById('enter_email_input').value;
    if(request_type === "warranty"){
        optIn = document.getElementById('isSubscribed').checked;
        if(!optIn){
            return
        }
    }else{
        optIn = document.getElementById('klaviyo-optin').checked;
        if(!optIn){
            return
        }
    }

    let selected_model_type = "Formula Pro Advanced";

    if (model_type === "advanced") {
        selected_model_type = "Formula Pro Advanced";
    } else if (model_type === "advanced_wifi") {
        selected_model_type = "Formula Pro Advanced WiFi";
    } else if (model_type === "pro_mini") {
        selected_model_type = "Formula Pro Mini";
    } else {
        selected_model_type = "Formula Pro Advanced";
    }


    try {
        let params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "revision": "2023-10-15"
            },
            body: JSON.stringify({
                email: email,
                store: "ME",
                selectedProduct: selected_model_type
            })
        };
        // params.body.selectedProduct = selectedProduct;
        const response = await fetch("https://optin.babybrezza.com/api/subscribe/klaviyo", params);

        if (!response.ok) {
            const error = await response.text();
            console.log(error)
            return
        }
    } catch (err) {
        console.log(err)
    }



}
function showToast(message,type,link = "",link_text= "") {
    // Create a completely new toast for this message
    if(document.getElementById("toast-item")) document.getElementById("toast-item").remove()
    const newToast = document.createElement('div');
    newToast.className = 'dynamic-toast';
    // Add the toast to the warranty form container if it exists, otherwise to body
    document.body.appendChild(newToast);
    let bgColor = "#fff"
    let colorItem = "#000"
    let icon = `<svg class="icon icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path fill="${colorItem}" stroke="#fff" d="M16.136 6.979h0l.003-.004a1.499 1.499 0 00-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 103.94 12.06l2.999 3s0 0 0 0c.289.29.675.44 1.1.439h.019a1.5 1.5 0 001.08-.522l6.998-7.998z"/>
                        </svg>`
    if(type === "error"){
        bgColor = "#fff"
        colorItem = "#a60f00"
        icon = '<svg class="icon icon-tick" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.033 16.01c.564-1.789 1.632-3.932 1.821-4.474.273-.787-.211-1.136-1.74.209l-.34-.64c1.744-1.897 5.335-2.326 4.113.613-.763 1.835-1.309 3.074-1.621 4.03-.455 1.393.694.828 1.819-.211.153.25.203.331.356.619-2.498 2.378-5.271 2.588-4.408-.146zm4.742-8.169c-.532.453-1.32.443-1.761-.022-.441-.465-.367-1.208.164-1.661.532-.453 1.32-.442 1.761.022.439.466.367 1.209-.164 1.661z"/></svg>'
    }
    newToast.id = "toast-item";
    let link_section = ""
    if(link !== "" && link_text !== "" ){
        link_section = `<div><a href="${link}" class="reversed-link btn btn--underline text-sm">${link_text}</a></div>`
    }
    // Set content
    newToast.innerHTML = `
            ${icon}
            <div class="toast-text font-bold ">${message} <br/> ${link_section}</div>
        `;
    // Fix styling issues that might be causing visibility problems
    newToast.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, calc(-50% + 16px));
            z-index: 99999;
            display: flex;
            opacity: 0;
            visibility: visible;
            transition: transform 0.5s ease, opacity 0.5s ease;
            border: 1px solid #f2f2f2;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
            border-radius: 4px;
            background-color: #fff;
            max-width: 90%;
            width: auto;
        `;

    // Style the toast text
    const textElement = newToast.querySelector('.toast-text');
    if (textElement) {
        textElement.style.cssText = `
                padding: 15px 20px;
                background-color: ${bgColor};
                color: #000;
                border-radius: 0 4px 4px 0;
                width: max-content;
                font-size: 16px;
                font-weight: 500;
            `;
        if(window.innerWidth < 430){
            textElement.style.cssText = `
                padding: 15px 20px;
                background-color: ${bgColor};
                color: #000;
                border-radius: 0 4px 4px 0;
                width: max-content;
                font-size: 14px;
                font-weight: 500;
            `;
        }
    }

    // Style the icon
    const iconElement = newToast.querySelector('.icon');
    if (iconElement) {
        iconElement.style.cssText = `
                width: 55px;
                ${link_section === "" ? "height: 100%;" : "height:90px;"}
                padding: 10px;
                background-color: #fff;
                ${link_section === "" ? "box-shadow: 0px 4px 10px rgb(19 152 128 / 30%);" : ""}
                border-radius: 4px 0 0 4px;
                display: flex;
                align-items: center;
                justify-content: center;
            `;
    }

    // Force the toast to be visible (ekranin tam ortasi - masaustu ve mobil ayni)
    setTimeout(() => {
        newToast.style.opacity = '1';
        newToast.style.transform = 'translate(-50%, -50%)';
    }, 10);

    // Ekranda kalma suresi: 4 sn (eskiden 2.5 sn), ardindan 0.5 sn fade-out.
    setTimeout(() => {
        newToast.style.opacity = '0';
        newToast.style.transform = 'translate(-50%, calc(-50% + 16px))';
        setTimeout(() => {
            newToast.remove();
        }, 500);
    }, 4000);
}
function validEmail(email) {
    if (!email) return false;

    email = email.trim().toLowerCase();

    // 1️⃣ Basic format check (RFC-uyumlu, ama katı değil)
    const emailRegex =
        /^[a-z0-9](?:[a-z0-9._%+-]{0,62}[a-z0-9])?@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z]{2,})+$/i;

    if (!emailRegex.test(email)) return false;

    // 2️⃣ Ardışık nokta / nokta ile başlama-bitme
    if (email.includes('..')) return false;
    if (email.startsWith('.') || email.endsWith('.')) return false;

    // 3️⃣ Yaygın fake / test / placeholder domainler
    const blockedDomains = [
        'test.com',
        'example.com',
        'example.org',
        'example.net',
        'email.com',
        'mail.com',
        'fake.com',
        'invalid.com',
        'localhost'
    ];

    const domain = email.split('@')[1];
    if (blockedDomains.includes(domain)) return false;

    // 4️⃣ Disposable / temp mail provider’ları (en yaygınlar)
    const disposableDomains = [
        'mailinator.com',
        'tempmail.com',
        '10minutemail.com',
        'guerrillamail.com',
        'yopmail.com',
        'trashmail.com',
        'dispostable.com',
        'getnada.com',
        'temp-mail.org'
    ];

    if (disposableDomains.includes(domain)) return false;

    // 5️⃣ Aşırı kısa veya saçma local-part
    const localPart = email.split('@')[0];
    if (localPart.length < 2) return false;
    if (/^[0-9]+$/.test(localPart)) return false;

    return true;
}

$(document).ready(function () {
    $.ajaxSetup({cache: false}); // or iPhones don't get fresh data
    GetTerritoryData(StoreURL);

    $("#tool_filter .additional-info-btn").click(() => {
        scrollToID("#additional_info_mobile");
    });

    // Tablo sonradan uretildigi icin delegated binding.
    $(document).on("click", "[data-formula-image]", function () {
        openFormulaImageModal(
            this.getAttribute("data-formula-image"),
            this.getAttribute("alt")
        );
    });

    $("#upc_enter").on("keypress click", function (e) {
        // Varsayilan davranisi her durumda engelle; hata halinde de sayfa
        // basa siçramasin / form submit olmasin.
        e.preventDefault();

        if (!checkEmailSubmit()) {
            $("#sel_type").prop("selectedIndex", 0);
            focusEmailInput();
            return;
        }

        if (e.which === 13 || e.type === "click") {
            let upc = $("#upc_input").val();

            upc = String(upc).trim();

            if (upc) {
                upc = upc.replace(/[^a-z0-9]/gi, "");
                findByUpc(upc);
            }
        }
    });

    $("#start_upc, #upc_start").on("keypress click", function (e) {
        // href="#" oldugu icin varsayilani engellemezsek sayfa basa siçriyor.
        e.preventDefault();

        if (!checkEmailSubmit()) {
            $("#sel_type").prop("selectedIndex", 0);
            focusEmailInput();
            return;
        }

        if (e.which === 13 || e.type === "click") {

            navigator.mediaDevices
                .enumerateDevices()
                .then(function (devices) {
                    hasCamera = devices.some(function (device) {
                        return device.kind === "videoinput";
                    });
                    if (hasCamera) {
                        $("#result").html("");
                        Quagga.init(
                            {
                                inputStream: {
                                    name: "Live",
                                    type: "LiveStream",
                                    target: document.querySelector("#interactive"),
                                    constraints: {
                                        facingMode: "environment", // or "user" for front camera
                                    },
                                },
                                decoder: {
                                    readers: ["upc_reader", "ean_reader"], // or other supported barcode types
                                },
                                locator: {
                                    patchSize: 5,
                                    halfSample: false,
                                },
                                numOfWorkers: navigator.hardwareConcurrency || 1,
                                frequency: 20,
                                locate: true,
                            },
                            function (err) {
                                if (err) {
                                    console.error(err);
                                    return;
                                }
                                console.log("Initialization finished. Ready to start");
                                Quagga.start();
                                $("#interactive").show();

                                Quagga.onProcessed(function (result) {
                                    var drawingCtx = Quagga.canvas.ctx.overlay;
                                    var drawingCanvas = Quagga.canvas.dom.overlay;

                                    drawingCtx.clearRect(
                                        0,
                                        0,
                                        parseInt(drawingCanvas.getAttribute("width")),
                                        parseInt(drawingCanvas.getAttribute("height"))
                                    );

                                    // if (result && result.boxes) {
                                    //   drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                                    //   result.boxes.filter(function(box) {
                                    //     return box !== result.box;
                                    //   }).forEach(function(box) {
                                    //     drawingCtx.strokeStyle = "#00FF00";
                                    //     drawingCtx.lineWidth = 2;
                                    //     drawingCtx.strokeRect(box.x, box.y, box.width, box.height);
                                    //   });
                                    // }

                                    if (result && result.box) {
                                        Quagga.ImageDebug.drawPath(
                                            result.box,
                                            {x: 0, y: 1},
                                            drawingCtx,
                                            {color: "#00F", lineWidth: 2}
                                        );
                                    }

                                    if (result && result.codeResult && result.codeResult.code) {
                                        // Barcode detected, do further processing here
                                        console.log("Barcode detected: " + result.codeResult.code);
                                        addInformationToKlaviyo().then(r => console.log("Successfully registered klaviyo"));
                                    }
                                });
                            }
                        );
                    } else {
                        $("#result").html(
                            '<p style="font-size: 16px; font-weight: 700; text-transform: uppercase; margin:0; color: red;">No camera detected<p>'
                        );
                    }
                })
                .catch(function (err) {
                    // An error occurred while accessing media devices
                    console.error("Error accessing media devices:", err);
                });
        }
    });
});

function checkEmailSubmit() {
    // Get the input value
    var emailInput = document.getElementById("enter_email_input");

    if (!emailInput) {
        return true;
    }

    var email = emailInput.value;

    // Regular expression for email validation
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the email matches the regular expression
    if (emailRegex.test(email)) {
        $("#invalid_email").hide();
        $("#enter_email_input").removeClass("invalid");
        return true;
    } else {
        $("#invalid_email").show();
        $("#enter_email_input").addClass("invalid");

        // Satir ici hatanin yaninda ortada toast da goster.
        // Metni #invalid_email'den okuyoruz ki tema ayari/cevirisiyle senkron kalsin.
        if (typeof showToast === "function") {
            var invalidMsg = $.trim($("#invalid_email").text());
            showToast(invalidMsg || "Please enter a valid email address", "error", "", "");
        }

        return false;
    }
}

function findByUpc(upc) {
    $("#upc_results").show();
    $("#sel_territory").prop("selectedIndex", 0);
    $("#sel_brand").html(
        '<option value="">--  Choose Your Formula Brand --</option>'
    );
    $("#sel_brand").prop("selectedIndex", 0);
    $("#sel_type").html(
        '<option value="">-- Choose Your Formula Stage/Age Range --</option>'
    );
    $("#sel_type").prop("selectedIndex", 0);

    $("#upc_settings").show();

    var showNoResult = function () {
        $("#upc_settings").html(
            '<h2 style="text-transform: none; margin-top: 20px; margin-bottom: 15px; font-size: 20px; text-align: center; font-weight: 700;"><strong>No Results Found For Barcode:</strong> ' +
            formulaEscapeHtml(upc) +
            "<br>Please select formula brand/type above</h2>"
        );
        $("#find_stage_setting").html("");
        $("#formula_pro_filter .Formula_sign_up_con").hide();
    };

    ensureFormulaLoadingStyles();
    $("#find_stage_setting").html(
        '<p class="formula-loading-text">' +
        formulaEscapeHtml(formulaLoadingLabel()) +
        "</p>"
    );

    formulaApiGet("/settings/upc", { upc: upc })
        .then(function (data) {
            var items = Array.isArray(data) ? data : data ? [data] : [];

            var found = items.filter(function (item) {
                var hasSetting =
                    item &&
                    item.setting !== undefined &&
                    item.setting !== null &&
                    item.setting !== "";
                var arr = item && Array.isArray(item.upc) ? item.upc : [];
                return hasSetting || arr.length > 0;
            });

            if (!found.length) {
                showNoResult();
                return;
            }

            $("#upc_settings").html(
                '<h2 style="text-transform: none; margin-top: 20px; margin-bottom: 15px; font-size: 20px; text-align: center; font-weight: 700;"><strong>Results for Barcode:</strong> ' +
                formulaEscapeHtml(upc) +
                "</h2>"
            );

            var rows = found.map(function (item) {
                var stageLabel =
                    item.stage !== undefined &&
                    item.stage !== null &&
                    item.stage !== ""
                        ? item.stage
                        : item.type || "";
                return {
                    stage: stageLabel,
                    setting: item.setting,
                    territory: item.territory,
                    image: item.image || item.images || [],
                };
            });

            $("#find_stage_setting").html(formulaUpcTableHtml(rows));

            $("#formula_pro_filter .Formula_sign_up_con").show();
            scrollToID("#formula_pro_filter .Formula_sign_up_con");

            addInformationToKlaviyo().then(r => console.log("Successfully registered klaviyo"));
        })
        .catch(function (err) {
            console.error("Formula API /settings/upc:", err);
            showNoResult();
        });
}

function proc(model_type) {
    $("#choose_brand_link").hide();
    $("#choose_stage_link").hide();

    if (model_type == "advanced") {
        selected_model_type = "Formula Pro Advanced";
        jQuery("#add_adv").addClass("active");
        jQuery("#add_adv_wifi, #add_pro_mini").removeClass("active");

        isProAdvanced = false;
        $("#contactFormProduct option[value='553111519266']").prop(
            "selected",
            true
        );
    } else if (model_type == "advanced_wifi") {
        selected_model_type = "Formula Pro Advanced WiFi";
        jQuery("#add_adv_wifi").addClass("active");
        jQuery("#add_adv, #add_pro_mini").removeClass("active");
        isProAdvanced = true;
        $("#contactFormProduct option[value='4390264078370']").prop(
            "selected",
            true
        );
    } else if (model_type == "pro_mini") {
        selected_model_type = "Formula Pro Mini";
        jQuery("#add_pro_mini").addClass("active");
        jQuery("#add_adv, #add_adv_wifi").removeClass("active");
        isProAdvanced = false;
        $("#contactFormProduct option[value='7084746244276']").prop(
            "selected",
            true
        );
    }

    $("#productSelectionDiv").hide();
    $("#warranty_regi_div").show();

    // Turnstile gizli kapsayicida otomatik render olmuyor; form gorunur olunca
    // explicit render tetikleniyor (bkz. wholescale-formula-new-form.liquid).
    if (typeof window.renderWarrantyTurnstile === "function") {
        window.renderWarrantyTurnstile();
    }

    //$("#tool_filter").show();

    jQuery("#model_type").val("advanced");

    GetTerritoryData();
    scrollToID("#formula_pro_filter");
}

function GetTerritoryData() {
    // Set default option text based on language
    const brandOptionText = languageCode === 'ar'
        ? '-- اختر ماركة الحليب --'
        : '-- Choose Your Formula Brand --';

    const stageOptionText = languageCode === 'ar'
        ? '-- اختر مرحلة/عمر الطفل --'
        : '-- Choose Your Formula Stage/Age Range --';

    const territoryOptionText = languageCode === 'ar'
        ? '-- اختر بلد/منطقة منشأ الحليب --'
        : '-- Choose the Country/Territory of Origin of Your Formula --';

    $("#sel_brand").html(`<option value="">${brandOptionText}</option>`);
    $("#sel_brand").prop("selectedIndex", 0);

    $("#sel_type").html(`<option value="">${stageOptionText}</option>`);
    $("#sel_type").prop("selectedIndex", 0);

    $("#find_stage_setting").html("");

    setSelectLoading("#sel_territory", true);

    formulaApiGet("/territories")
        .then(function (data) {
            if (!Array.isArray(data)) throw new Error("Invalid territory data");
            // Deger encodeURIComponent'li: mevcut "European%20Union" karsilastirmalari korunuyor.
            $("#sel_territory").html(
                formulaOptionsHtml(data, territoryOptionText, true)
            );
            $("#sel_territory").prop("selectedIndex", 0);
        })
        .catch(function (err) {
            console.error("Formula API /territories:", err);
            // Hata halinde bos birakma; varsayilan secenegi geri koy.
            $("#sel_territory").html(
                '<option value="">' + territoryOptionText + "</option>"
            );
        })
        .finally(function () {
            setSelectLoading("#sel_territory", false);
        });
}

function getbrand(val) {
    if (!checkEmailSubmit()) {
        $("#sel_territory").prop("selectedIndex", 0);
        focusEmailInput();
        return;
    }

    selected_country_code = val;
    $("#choose_brand_link").css("display", "inline-block");
    $("#choose_stage_link").hide();

    $("#missing_brand").attr(
        "href",
        salesforce_url +
        "product=" +
        selected_model_type +
        "&country=" +
        selected_country_code
    );

    if (val === "European%20Union") {
        isEU = true;
    } else {
        isEU = false;
    }

    // hidden field set territory id
    $("#sel_territory_id").val("");
    $("#sel_brand_id").val("");
    $("#sel_type_id").val("");
    $("#sel_territory_id").val(val);

    $(
        "#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip"
    ).hide();
    if (val == "United%20States%20of%20America") {
        $(
            "#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip"
        ).show();
    }
    $("#choose_type").show();
    $("#sel_type").html(
        '<option value="">-- Choose Your Formula Stage/Age Range --</option>'
    );
    $("#sel_type").prop("selectedIndex", 0);

    $("#find_stage_setting").html("");

    const stageOptionText = languageCode === 'ar'
        ? '-- اختر مرحلة/عمر الطفل --'
        : '-- Choose Your Formula Stage/Age Range --';

    $("#sel_type").html(`<option value="">${stageOptionText}</option>`);
    $("#sel_type").prop("selectedIndex", 0);

    const brandOptionText = languageCode === 'ar'
        ? '-- اختر ماركة الحليب --'
        : '-- Choose Your Formula Brand --';

    setSelectLoading("#sel_brand", true);

    formulaApiGet("/brands", { territory: formulaSafeDecode(val) })
        .then(function (data) {
            $("#sel_brand").html(
                formulaOptionsHtml(
                    Array.isArray(data) ? data : [],
                    brandOptionText,
                    false
                )
            );
            $("#sel_brand").prop("selectedIndex", 0);
        })
        .catch(function (err) {
            console.error("Formula API /brands:", err);
            $("#sel_brand").html(
                '<option value="">' + brandOptionText + "</option>"
            );
        })
        .finally(function () {
            setSelectLoading("#sel_brand", false);
        });
}

function gettypepro(val) {
    if (!checkEmailSubmit()) {
        $("#sel_brand").prop("selectedIndex", 0);
        focusEmailInput();
        return;
    }

    selected_formula_brand = val;
    $("#choose_stage_link").css("display", "inline-block");
    $("#missing_stage").attr(
        "href",
        salesforce_url +
        "product=" +
        selected_model_type +
        "&country=" +
        selected_country_code +
        "&formula_name=" +
        selected_formula_brand
    );

    // hidden field set brand id
    $("#sel_brand_id").val("");
    $("#sel_type_id").val("");
    $("#sel_brand_id").val(val);

    var territory_id = $("#sel_territory_id").val();

    $("#choose_type").show();
    $("#find_stage_setting").html("");

    const stageOptionText = languageCode === 'ar'
        ? '-- اختر مرحلة/عمر الطفل --'
        : '-- Choose Your Formula Stage/Age Range --';

    setSelectLoading("#sel_type", true);

    formulaApiGet("/types", {
        territory: formulaSafeDecode(territory_id),
        brand: formulaSafeDecode(val),
    })
        .then(function (data) {
            var types = Array.isArray(data) ? data : [];

            if (types.length) {
                $("#choose_type").show();
                $("#sel_type").html(
                    formulaOptionsHtml(types, stageOptionText, false)
                );
                // NOT: burada eskiden `$("#sel_type option:eq(1)").change()` vardi.
                // Bir <option> uzerinde .change() select'in selectedIndex'ini
                // degistirmedigi icin inline onChange bos deger ile calisiyor ve
                // /stages?type= istegi 400 donuyordu. Kullanici tipi kendisi
                // sectiginde zaten dogru zincir tetikleniyor.
            } else {
                // Bu marka icin tip yok -> eski getbrandtosetting davranisindaki
                // gibi dogrudan ayarlara gec.
                $("#choose_type").hide();
                formulaLoadSettings("");
            }
        })
        .catch(function (err) {
            console.error("Formula API /types:", err);
            $("#sel_type").html(
                '<option value="">' + stageOptionText + "</option>"
            );
        })
        .finally(function () {
            setSelectLoading("#sel_type", false);
        });
}

var glob_val;

function getstagesettign(val) {
    if (!checkEmailSubmit()) {
        $("#sel_type").prop("selectedIndex", 0);
        focusEmailInput();
        return;
    }

    $("#upc_settings").hide();
    $("#upc_input").val("");

    glob_val = val;

    // hidden field set type id
    $("#sel_type_id").val("");
    $("#sel_type_id").val(val);

    $("#find_stage_setting").html("");

    formulaLoadSettings(val);
}

function getData() {
    return formulaLoadSettings(glob_val);
}

/* Secili territory + brand + type icin once stage listesini, sonra her stage'in
   ayarini ceker. Eski API bunu tek HTML parcasi olarak donuyordu; yeni API JSON
   dondugu icin markup burada uretiliyor. */
function formulaLoadSettings(typeVal) {
    var rawTerritory = formulaSafeDecode($("#sel_territory_id").val());
    var rawBrand = formulaSafeDecode($("#sel_brand_id").val());
    var rawType = formulaSafeDecode(typeVal || "");

    sendLegacySettingsLog(rawTerritory, rawBrand, rawType);

    // /stages + her stage icin ayri /settings cagrisi yapiliyor; en uzun suren
    // adim bu, o yuzden sonuc alaninda da yukleniyor gosteriyoruz.
    ensureFormulaLoadingStyles();
    $("#find_stage_setting").html(
        '<p class="formula-loading-text">' +
        formulaEscapeHtml(formulaLoadingLabel()) +
        "</p>"
    );

    return formulaApiGet("/stages", {
        territory: rawTerritory,
        brand: rawBrand,
        type: rawType,
    })
        .then(function (stagesData) {
            if (!Array.isArray(stagesData) || !stagesData.length) return [];

            return Promise.all(
                stagesData.map(function (stageItem) {
                    var stageValue;
                    var stageName;

                    if (stageItem && typeof stageItem === "object") {
                        stageValue =
                            stageItem.stage !== undefined && stageItem.stage !== null
                                ? stageItem.stage
                                : stageItem.number !== undefined &&
                                  stageItem.number !== null
                                ? stageItem.number
                                : "";
                        stageName =
                            stageItem.name !== undefined && stageItem.name !== null
                                ? stageItem.name
                                : stageItem.label !== undefined &&
                                  stageItem.label !== null
                                ? stageItem.label
                                : String(stageValue);
                    } else {
                        stageValue = String(stageItem);
                        stageName = stageValue;
                    }

                    var settingsParams = {
                        territory: rawTerritory,
                        brand: rawBrand,
                        type: rawType,
                    };
                    if (
                        stageValue !== "" &&
                        stageValue !== undefined &&
                        stageValue !== null
                    ) {
                        settingsParams.stage = stageValue;
                    }

                    return formulaApiGet("/settings", settingsParams).then(
                        function (settingsData) {
                            return {
                                stage: stageName,
                                stageNum: stageValue,
                                setting: settingsData
                                    ? settingsData.setting
                                    : undefined,
                                upc: (settingsData && settingsData.upc) || [],
                                image: (settingsData && settingsData.image) || [],
                            };
                        }
                    );
                })
            );
        })
        .then(function (rows) {
            formulaRenderSettings(rows);
        })
        .catch(function (err) {
            console.error("Formula API /stages|/settings:", err);
            $("#find_stage_setting").html("");
        });
}

function formulaRenderSettings(rows) {
    var country_code = getCookie("country");

    var html =
        formulaSettingsTableHtml(rows) +
        formulaImagesHtml(formulaCollectImages(rows));

    $("#find_stage_setting").html("<div class='wrapper'>" + html + "</div>");

    $(".Formula_sign_up_con").show();
    $("#enjoy-msg, #fps-mail-cta, #more-products-wrapper").show();

    // Slick birden fazla kez init edilmesin.
    if (!$(".more-slider").hasClass("slick-initialized")) {
        $(".more-slider").slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            focusOnSelect: true,
            draggable: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4,
                    },
                },
            ],
        });
    } else {
        $(".more-slider").slick("setPosition");
    }

    // Namespace'li bind: her sonucta handler birikmesin.
    $(window)
        .off("resize.moreSlider orientationchange.moreSlider")
        .on("resize.moreSlider orientationchange.moreSlider", function () {
            if ($(".more-slider").hasClass("slick-initialized")) {
                $(".more-slider").slick("resize");
            }
        });

    if (country_code == "US") $("#shop-cross-wrapper").show();

    addInformationToKlaviyo().then(r => console.log("Successfully registered klaviyo"));

    scrollToID("#formula_pro_filter .Formula_sign_up_con");
}

window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type == "submit") {
        getData();
    }
});

var skipBtn = document.querySelector(".fpa_skip");
// console.log('skipBtn: ', skipBtn);
if (skipBtn) {
    skipBtn.addEventListener("click", function (e) {
        e.preventDefault();
        getData();
    });
}

/* =========================================================================
   Formula API katmani (babybrezzacloud.com)
   Eski babybrezzaserver.com uclari HTML <option>/<table> donuyordu ve senkron
   XHR ile cagriliyordu. Yeni API JSON donuyor; markup burada uretiliyor ki
   mevcut tasarim (#find_stage_setting CSS'i) birebir korunsun.
   ========================================================================= */

function formulaSafeDecode(v) {
    if (!v) return "";
    try {
        return decodeURIComponent(v);
    } catch (e) {
        return v;
    }
}

function formulaEscapeHtml(v) {
    return String(v === undefined || v === null ? "" : v)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

function formulaApiGet(path, params) {
    var qs = params ? new URLSearchParams(params).toString() : "";
    var url = FORMULA_API_URL + path + (qs ? "?" + qs : "");
    var controller =
        typeof AbortController !== "undefined" ? new AbortController() : null;
    var timer = controller
        ? setTimeout(function () {
              controller.abort();
          }, FORMULA_API_TIMEOUT)
        : null;

    return fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) {
            if (timer) clearTimeout(timer);
            if (!res.ok) throw new Error("HTTP " + res.status + " - " + url);
            return res.json();
        })
        .catch(function (err) {
            if (timer) clearTimeout(timer);
            throw err;
        });
}

// Eski PHP ucuna analitik logu (yanit beklenmiyor, hata yutuluyor).
function sendLegacySettingsLog(territory, brand, type) {
    try {
        var fd = new URLSearchParams();
        fd.append("type_id", type || "");
        fd.append("brand_id", brand ? encodeURIComponent(brand) : "");
        fd.append("territory_id", territory || "");
        fd.append("model_type", $("#model_type").val() || "");
        fd.append("email", $("#enter_email_input").val() || "");
        fd.append(
            "language",
            typeof languageCode !== "undefined" ? languageCode : "en"
        );
        fd.append("ip_address", getUserCookie("ip_address"));
        fd.append("user_agent", navigator.userAgent);
        fd.append(
            "touch_device",
            String("ontouchstart" in window || navigator.maxTouchPoints > 0)
        );
        fd.append("state_prov", getUserCookie("state_prov"));
        fd.append("zip", getUserCookie("zip"));
        fd.append("country", getUserCookie("country"));
        fd.append("city", getUserCookie("city"));
        fd.append("babyb_store", "babybrezza.me");

        fetch(FORMULA_LEGACY_LOG_URL, {
            method: "POST",
            body: fd,
            keepalive: true,
        }).catch(function () {});
    } catch (e) {}
}

/* ---------- Markup uretecleri (mevcut CSS ile uyumlu) ---------- */

/* ---------- Yukleniyor durumu ----------
   Sunucudan veri gelene kadar ilgili select devre disi kalir ve "Loading..."
   gosterir; boylece kullanici bos bir listeye tiklamaz. */
function ensureFormulaLoadingStyles() {
    if (document.getElementById("formula-loading-styles")) return;

    var style = document.createElement("style");
    style.id = "formula-loading-styles";
    style.textContent =
        "select.formula-loading{opacity:.65;cursor:wait;" +
        "background-image:none !important;}" +
        "#find_stage_setting .formula-loading-text{text-align:center;" +
        "padding:20px 0;color:#80828a;font-size:16px;}";

    document.head.appendChild(style);
}

function formulaLoadingLabel() {
    return typeof languageCode !== "undefined" && languageCode === "ar"
        ? "جارٍ التحميل..."
        : "Loading...";
}

function setSelectLoading(selector, isLoading) {
    var $sel = $(selector);
    if (!$sel.length) return;

    ensureFormulaLoadingStyles();

    if (isLoading) {
        $sel.html(
            '<option value="">' + formulaEscapeHtml(formulaLoadingLabel()) + "</option>"
        );
        $sel.prop("selectedIndex", 0);
        $sel.prop("disabled", true).addClass("formula-loading");
    } else {
        $sel.prop("disabled", false).removeClass("formula-loading");
    }
}

function formulaOptionsHtml(items, defaultLabel, encodeValue) {
    var html = '<option value="">' + formulaEscapeHtml(defaultLabel) + "</option>";
    (items || []).forEach(function (item) {
        var value = encodeValue ? encodeURIComponent(item) : item;
        html +=
            '<option value="' +
            formulaEscapeHtml(value) +
            '">' +
            formulaEscapeHtml(item) +
            "</option>";
    });
    return html;
}

function formulaSettingsTableHtml(rows) {
    var isAr = typeof languageCode !== "undefined" && languageCode === "ar";
    if (!rows || !rows.length) {
        return (
            "<p>" +
            (isAr
                ? "لم يتم العثور على إعدادات لهذا الحليب."
                : "No settings found for this formula.") +
            "</p>"
        );
    }
    var body = rows
        .map(function (r) {
            var settingVal =
                r.setting === undefined || r.setting === null || r.setting === ""
                    ? "-"
                    : r.setting;
            return (
                "<tr><td>" +
                formulaEscapeHtml(r.stage) +
                "</td><td>" +
                formulaEscapeHtml(settingVal) +
                "</td></tr>"
            );
        })
        .join("");

    return (
        "<table><tr><th>" +
        (isAr ? "المرحلة" : "STAGE") +
        "</th><th>" +
        (isAr ? "الإعداد" : "SETTING") +
        "</th></tr>" +
        body +
        "</table>"
    );
}

/* Grid icin medya sorgusu gerekiyor; inline style ile yapilamadigindan
   tek seferlik bir <style> blogu enjekte ediyoruz. */
function ensureFormulaImageGridStyles() {
    if (document.getElementById("formula-image-grid-styles")) return;

    var style = document.createElement("style");
    style.id = "formula-image-grid-styles";
    // Flex + justify-content:center kullaniyoruz. Grid'de repeat(4,1fr) her zaman
    // 4 sutun uretiyordu; tek gorsel oldugunda bos sutunlar yer kaplayip gorseli
    // sola yasliyordu. Flex'te satir icerige gore daralir ve ortalanir:
    // 1, 2, 3 veya 4 gorsel - hepsi ortali cikar.
    style.textContent =
        ".formula-images-grid{display:flex;flex-wrap:wrap;justify-content:center;" +
        "gap:16px;margin:24px auto 0;max-width:1180px;}" +
        ".formula-images-grid .formula-image-wrapper{margin:0;" +
        "flex:0 1 calc((100% - 48px) / 4);max-width:250px;}" +
        ".formula-images-grid .formula-image{width:100%;height:auto;" +
        "max-height:300px;object-fit:contain;display:block;cursor:zoom-in;" +
        "margin-left:auto;margin-right:auto;}" +
        "@media (max-width:749px){" +
        ".formula-images-grid{gap:12px;}" +
        ".formula-images-grid .formula-image-wrapper{" +
        "flex:0 1 calc((100% - 12px) / 2);}}";

    document.head.appendChild(style);
}

function formulaImagesHtml(images) {
    if (!images || !images.length) return "";

    ensureFormulaImageGridStyles();

    var cells = images
        .map(function (image) {
            var src = FORMULA_IMAGE_BASE + "/" + image;
            return (
                '<div class="formula-image-wrapper">' +
                '<img class="formula-image" data-formula-image="' +
                formulaEscapeHtml(src) +
                '" alt="' +
                formulaEscapeHtml(image) +
                '" src="' +
                formulaEscapeHtml(src) +
                '" loading="lazy"/></div>'
            );
        })
        .join("");

    return '<div class="formula-images-grid">' + cells + "</div>";
}

function formulaCollectImages(rows) {
    var seen = {};
    var all = [];
    (rows || []).forEach(function (r) {
        (r.image || []).forEach(function (img) {
            if (!seen[img]) {
                seen[img] = true;
                all.push(img);
            }
        });
    });
    return all;
}

/* ---------- UPC sonuc tablosu ----------
   /settings/upc ucu her territory icin ayri bir kayit donuyor; bu yuzden
   burada STAGE + SETTING'e ek olarak COUNTRY ve satira ait IMAGE sutunlari
   var. Dropdown akisi (formulaSettingsTableHtml) 2 sutunlu kaliyor - orada
   territory zaten kullanicinin sectigi tek deger. */
function formulaUpcTableHtml(rows) {
    var isAr = typeof languageCode !== "undefined" && languageCode === "ar";

    if (!rows || !rows.length) {
        return (
            "<p>" +
            (isAr
                ? "لم يتم العثور على إعدادات لهذا الحليب."
                : "No settings found for this formula.") +
            "</p>"
        );
    }

    var body = rows
        .map(function (r) {
            var settingVal =
                r.setting === undefined || r.setting === null || r.setting === ""
                    ? "-"
                    : r.setting;

            var territory = Array.isArray(r.territory)
                ? r.territory.filter(Boolean).join(", ")
                : r.territory || "-";

            var imgs = r.image || [];
            var imgCell = imgs.length
                ? imgs
                      .map(function (img) {
                          var src = FORMULA_IMAGE_BASE + "/" + img;
                          return (
                              '<img data-formula-image="' +
                              formulaEscapeHtml(src) +
                              '" src="' +
                              formulaEscapeHtml(src) +
                              '" alt="' +
                              formulaEscapeHtml(img) +
                              '" loading="lazy" style="width:64px;height:64px;' +
                              "object-fit:contain;cursor:zoom-in;display:inline-block;" +
                              "margin:2px;padding:2px;border:1px solid #e5e5e5;" +
                              'border-radius:4px;background:#fff;vertical-align:middle;"/>'
                          );
                      })
                      .join("")
                : "-";

            return (
                "<tr><td>" +
                formulaEscapeHtml(r.stage) +
                "</td><td>" +
                formulaEscapeHtml(settingVal) +
                "</td><td>" +
                formulaEscapeHtml(territory) +
                "</td><td>" +
                imgCell +
                "</td></tr>"
            );
        })
        .join("");

    // max-width temadaki 500px kuralini eziyor: 4 sutun icin dar kaliyordu.
    return (
        '<div style="overflow-x:auto;">' +
        '<table style="max-width:900px;width:100%;">' +
        "<tr><th>" +
        (isAr ? "المرحلة" : "STAGE") +
        "</th><th>" +
        (isAr ? "الإعداد" : "SETTING") +
        "</th><th>" +
        (isAr ? "الدولة" : "COUNTRY") +
        "</th><th>" +
        (isAr ? "الصورة" : "IMAGE") +
        "</th></tr>" +
        body +
        "</table></div>"
    );
}

/* ---------- Tam genislikte gorsel modali ---------- */
function ensureFormulaImageModal() {
    if (document.getElementById("formula-image-modal")) return;

    var overlay = document.createElement("div");
    overlay.id = "formula-image-modal";
    overlay.setAttribute("aria-hidden", "true");
    overlay.style.cssText =
        "position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999999999999;" +
        "display:none;align-items:center;justify-content:center;" +
        "background:rgba(0,0,0,0.85);";

    overlay.innerHTML =
        '<button type="button" id="formula-image-modal-close" aria-label="Close" ' +
        'style="position:absolute;top:16px;right:20px;width:44px;height:44px;' +
        "border:none;background:rgba(255,255,255,0.15);color:#fff;font-size:28px;" +
        'line-height:1;border-radius:50%;cursor:pointer;z-index:1;">&times;</button>' +
        '<img id="formula-image-modal-img" alt="" ' +
        'style="max-width:90vw;max-height:90vh;width:auto;height:auto;' +
        'object-fit:contain;display:block;cursor:default;"/>';

    document.body.appendChild(overlay);

    var close = function () {
        overlay.style.display = "none";
        overlay.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
    };

    overlay.addEventListener("click", function (e) {
        // Gorselin kendisi disinda her yere tiklanınca kapansin (overlay + kapat butonu).
        // Not: gorsel 90vw/90vh oldugu icin cevresinde her zaman tiklanabilir alan kalir.
        if (e.target.id !== "formula-image-modal-img") {
            close();
        }
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" || e.keyCode === 27) close();
    });
}

function openFormulaImageModal(src, alt) {
    ensureFormulaImageModal();

    var overlay = document.getElementById("formula-image-modal");
    var img = document.getElementById("formula-image-modal-img");

    img.src = src;
    img.alt = alt || "";
    overlay.style.display = "flex";
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
}

function getUserCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
